export const products = [
  {
    id: 1,
    name: "Router Wi-Fi 6 ASUS RT-AX82U",
    description: "Router gaming dual-band cu Wi-Fi 6, perfect pentru streaming 4K și gaming online",
    price: 2999,
    image: "/img/product-router.jpg"
  },
  {
    id: 2,
    name: "Camera de Supraveghere 4K",
    description: "Cameră de supraveghere cu rezoluție 4K, vedere nocturnă și detecție mișcare",
    price: 1499,
    image: "/img/product-camera.jpg"
  },
  {
    id: 3,
    name: "Mesh Wi-Fi System",
    description: "Sistem Wi-Fi mesh pentru acoperire completă în toată casa",
    price: 3999,
    image: "/img/product-mesh-wifi.jpg"
  },
  {
    id: 4,
    name: "Switch Gigabit 8 Porturi",
    description: "Switch de rețea Gigabit cu 8 porturi pentru conexiuni rapide",
    price: 499,
    image: "/img/product-switch.jpg"
  },
  {
    id: 5,
    name: "Media Box Android TV",
    description: "Media player 4K cu Android TV pentru streaming și aplicații smart",
    price: 999,
    image: "/img/product-media-box.jpg"
  },
  {
    id: 6,
    name: "UPS 1500VA",
    description: "UPS pentru protecție și backup în caz de pană de curent",
    price: 1999,
    image: "/img/product-ups.jpg"
  },
  {
    id: 7,
    name: "Receptor Audio HT90",
    description: "Receptor audio de înaltă calitate pentru sisteme de interfon",
    price: 500,
    image: "/img/HT90.png"
  },
  {
    id: 8,
    name: "Receptor Audio Hands-Free SP-03",
    description: "Receptor audio hands-free modern pentru sisteme de interfon",
    price: 2500,
    image: "/img/SP03.png"
  },
  {
    id: 9,
    name: "Interfon Video IP AZ-07L",
    description: "Interfon video IP cu ecran LCD și funcții avansate de securitate",
    price: 5500,
    image: "/img/AZ07L.png"
  },
  {
    id: 10,
    name: "Interfon Video IP AT-07L",
    description: "Interfon video IP premium cu cameră HD și funcții smart",
    price: 7200,
    image: "/img/AT07L.png"
  }
];